import React from 'react'
import InlineSVG from 'components/InlineSVG'
import Loader from 'components/Loader'

import './newsletter.css'

const Newsletter = (props) => {
  let content
  const onSubmit = (e) => {
    e.preventDefault()
    props.submitHandler(props.email)
  }

  if (props.loading) {
    content = (
      <div className='input-wrapper'>
        <Loader
          color='#fff'
        />
      </div>
    )
  } else if (props.submitSuccess) {
    content = (
      <div className='input-wrapper'>
        {props.successMessage}
      </div>
    )
  } else {
    content = (
      <div className='input-wrapper'>
        <input
          placeholder='Enter your mail address here...'
          type='email'
          name='email'
          value={props.email}
          onChange={props.onInputChange}
        />
        <button type='submit'>Subscribe</button>
      </div>
    )
  }

  return (
    <form
      onSubmit={onSubmit}
      className='footer-newsletter'>
      <div className='container-fluid'>
        <InlineSVG
          icon='close'
          onClick={props.toggleNewsletter} />
        {content}
      </div>
    </form>
  )
}

export default Newsletter



// WEBPACK FOOTER //
// ./src/components/Footer/Newsletter/index.js